/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";
import { ɵNzTabNavOperationComponent } from "ng-zorro-antd/tabs";
import { UiTabNavItemDirective } from "../../directives/tab-nav-item.directive";

@Component({
  selector: "ui-tab-nav-operation",
  exportAs: "uiTabNavOperation",
  templateUrl: "./tab-nav-operation.component.html",
})
export class UiTabNavOperationComponent extends ɵNzTabNavOperationComponent {
  @Input() public items: UiTabNavItemDirective[] = [];
  @Input() public addable = false;
  @Input() public addIcon: string | TemplateRef<NzSafeAny> = "outline:plus";

  @Output() public readonly addClicked = new EventEmitter<void>();
  @Output() public readonly selected = new EventEmitter<UiTabNavItemDirective>();

  public constructor(public cdr: ChangeDetectorRef, elementRef: ElementRef<HTMLElement>) {
    super(cdr, elementRef);
  }
}
